module.exports = __webpack_public_path__ + "static/media/ciniphilia_ang_home.d3437dd8.gif";